import { MutationTree } from 'vuex'
import { ClassifiedActionsState } from './state'
import { SET_PENDING } from './mutation-types'

export default {
  [SET_PENDING](state, pendingValue: boolean) {
    state.pending = pendingValue
  }
} as MutationTree<ClassifiedActionsState>
